export const ORGANIZER_COLLECTIONS_PAGE_SIZE = 4;
